<script lang="ts">
    export let size: number, color: string
</script>

<svg fill="none" viewBox="0 0 24 24" width={size} height={size} xmlns="http://www.w3.org/2000/svg">
    <path style="stroke: {color}; stroke-width: 2px;" d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path
        style="stroke: {color}; stroke-width: 2px;"
        d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
    />
</svg>
